(() => {
  const init = () => {
    document.querySelectorAll('[data-ul-floating-cart]:not([data-ul-floating-ready])').forEach((bar) => {
      const section = bar.previousElementSibling;
      const productVisual = section?.querySelector('.ul-infographic__visual');
      const sizeButtons = Array.from(bar.querySelectorAll('[data-ul-floating-size]'));
      const variantInput = bar.querySelector('[data-ul-floating-variant]');
      const price = bar.querySelector('[data-ul-floating-price]');
      const submit = bar.querySelector('.ul-floating-cart__submit');
      const form = bar.querySelector('form');
      const scrollRoot = document.querySelector('.page-wrapper') || window;

      if (!(section instanceof HTMLElement) || !sizeButtons.length || !(variantInput instanceof HTMLInputElement)) return;

      bar.dataset.ulFloatingReady = 'true';

      const updateVariant = (variantId) => {
        const activeButton = sizeButtons.find((button) => button.dataset.ulFloatingSize === variantId && !button.disabled)
          || sizeButtons.find((button) => button.classList.contains('is-active') && !button.disabled)
          || sizeButtons.find((button) => !button.disabled);
        if (!activeButton) return;
        variantInput.value = activeButton.dataset.ulFloatingSize || '';
        if (price) {
          price.textContent = activeButton.dataset.ulPrice || '';
          price.classList.toggle('is-on-sale', activeButton.dataset.ulOnSale === 'true');
        }
        sizeButtons.forEach((button) => button.classList.toggle('is-active', button === activeButton));
        if (submit instanceof HTMLButtonElement) submit.disabled = false;
      };

      const updateVisibility = () => {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const sectionHasEntered = section.getBoundingClientRect().top <= window.innerHeight;
        const visualIsClear = !isMobile || !productVisual || productVisual.getBoundingClientRect().bottom <= window.innerHeight - bar.getBoundingClientRect().height - 8;
        const visible = sectionHasEntered && visualIsClear;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      };

      let frame = 0;
      const requestVisibilityUpdate = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          updateVisibility();
        });
      };

      sizeButtons.forEach((button) => button.addEventListener('click', (event) => {
        event.stopPropagation();
        updateVariant(button.dataset.ulFloatingSize);
      }));
      submit?.addEventListener('click', updateVariant);
      form?.addEventListener('submit', updateVariant, { capture: true });
      document.querySelector('[data-ul-product]')?.addEventListener('click', (event) => {
        const variantButton = event.target instanceof Element ? event.target.closest('[data-ul-variant]') : null;
        if (!variantButton || !variantButton.dataset.ulVariant) return;
        updateVariant(variantButton.dataset.ulVariant);
      });

      scrollRoot.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
      window.addEventListener('resize', requestVisibilityUpdate, { passive: true });
      updateVariant();
      setTimeout(updateVariant, 0);
      updateVisibility();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
